import React from 'react';

import { SVGProps } from './types';

export default function Triangle(props: SVGProps) {
  const fill = props.fill || 'currentColor';
  const secondaryfill = props.secondaryfill || fill;
  const width = props.width || '100%';
  const height = props.height || '100%';

  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <g fill={secondaryfill}>
        <path
          d="M12.8,4.4a1.036,1.036,0,0,0-1.6,0l-9,12A1,1,0,0,0,3,18H21a1,1,0,0,0,.8-1.6Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}
